<template>
  <div class="bg" v-show="show">
    
    <div class="wrapper">
      <img @click="cancel" class="close" src="../../assets/img/cloudEdit/close.png" alt="">
      <div class="project-container">
        <p>输入项目名称</p>
        <input v-model="info.title" placeholder="未命名项目" type="text">
      </div>

      <div class="size-container">
        <p>选择项目尺寸</p>
        <ul>
          <li @click="index = 1" :class="{on: index == 1}">
            <div class="wh"></div>
            <p>16:9</p>
          </li>
          <li @click="index = 2" :class="{on: index == 2}">
            <div class="hw"></div>
            <p>9:16</p>
          </li>
          <li @click="index = 3" :class="{on: index == 3}">
            <div class="ww"></div>
            <p>6:7</p>
          </li>
        </ul>
      </div>

      <div v-if="info.id && length > 1" class="pg-container">
        <p>素材一键辅轨</p>
        <div class="pg">
          <p @click="pgIndex = 1">
            <i :class="{on: pgIndex===1}"></i>
            <span>是</span>
          </p>
          <p @click="pgIndex = 0">
            <i :class="{on: pgIndex===0}"></i>
            <span>否</span>
          </p>
        </div>
      </div>

      <div @click="newInsert" class="btn-container">
        创建
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import vClickOutside from 'v-click-outside'

export default {
  name: 'cloudEditConfirm',
  data() {
    return {
      show: true,
      info: '',
      r: null,
      index: 1,
      canSubmit: true,
      pgIndex: 0,
      length: 1
    }
  },
  methods: {
    newInsert() {
      if(this.info.title == ''){
        this.$toast('项目名称不能为空')
      }else if(this.canSubmit){
        this.canSubmit = false;
        const info = {
          file_ids: this.info.id,
          type: 1,
          title: this.info.title,
          size: this.index == 1 ? '16:9' : this.index == 3 ? '6:7' : '9:16',
          track: this.pgIndex,
          subject_id: this.info.d,
          subject_type: this.info.t
        }

        common.myFetch(apis.editvideoInsert, {method: 'post', data: info})
        .then((data) => {
            this.canSubmit = true;
            if (!data) return
            this.close();
            this.r(data)
        })
      }
    },
    open(info, r) {
      console.log(info)
      let length = info.id.split(',')
      this.length = length.length
      info.title = '未命名项目'
      this.info = info
      this.r = r
      this.show = true
    },
    close() {
      this.show = false
    },
    confirm() {
      this.r(true)
      this.close()
    },
    cancel() {
      this.r(999)
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1222;

    .wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -420px;
      margin-top: -203px;
      width: 840px;
      min-height: 406px;
      background: #1C1E26;
      border-radius: 4px;
      padding: 50px 120px 43px;
      box-sizing: border-box;

      &>div {
        margin-bottom: 20px;

        &:nth-last-of-type(2) {
          margin-bottom: 42px;
        }
      }

      .close {
        position: absolute;
        top: 20px;
        right: 30px;
        width: 22px;
        height: 22px;
        cursor: pointer;
        user-select: none;
      }

      .project-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        // margin-bottom: 20px;

        p {
          width: 84px;
          font-size: 14px;
          color: #FFFFFF;
          margin-right: 20px;
        }

        input {
          width: 496px;
          height: 40px;
          background: #222631;
          border-radius: 4px;
          padding: 0 20px;
          font-size: 14px;
          color: #FFF;

          &::placeholder {
            color: #878A94;
          }
        }
      }

      .size-container {
        display: flex;
        flex-direction: row;
        // margin-bottom: 42px;

        &>p {
          width: 84px;
          font-size: 14px;
          color: #FFFFFF;
          margin-right: 20px;
        }

        ul {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-top: 10px;

          li {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 152px;
            height: 106px;
            background: #222631;
            border-radius: 4px;
            margin-right: 20px;
            user-select: none;
            cursor: pointer;

            &.on {
              border: 2px solid #4488FF;
              box-sizing: border-box;
            }

            &:nth-last-of-type(1) {
              margin-right: 0;
            }

            p {
              font-size: 14px;
              line-height: 20px;
              color: #878A94;
            }

            .wh {
              width: 44px;
              height: 28px;
              border: 3px solid #878A94;
              box-sizing: border-box;
              border-radius: 4px;
              margin-bottom: 16px;
            }

            .hw {
              width: 28px;
              height: 44px;
              border: 3px solid #878A94;
              box-sizing: border-box;
              border-radius: 4px;
              margin-bottom: 8px;
            }

            .ww {
              width: 42px;
              height: 36px;
              border: 3px solid #878A94;
              box-sizing: border-box;
              border-radius: 4px;
              margin-bottom: 12px;
            }
          }
        }
      }

      .pg-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        // margin-bottom: 20px;

        p {
          width: 84px;
          font-size: 14px;
          color: #FFFFFF;
          margin-right: 20px;
        }

        .pg {
          display: flex;
          flex-direction: row;
          align-items: center;

          p {
            display: flex;
            flex-direction: row;
            user-select: none;
            cursor: pointer;

            i {
              position: relative;
              display: block;
              width: 16px;
              height: 16px;
              border-radius: 8px;
              background: rgba(185, 195, 195, 0.15);
              margin-right: 8px;

              &.on {
                background: rgba(0, 126, 255, 1);

                &:after {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  margin-left: -3px;
                  margin-top: -3px;
                  display: block;
                  content: '';
                  width: 6px;
                  height: 6px;
                  border-radius: 8px;
                  background: #FFF;
                }
              }
            }

            span {
              display: block;
              font-size: 14px;
              line-height: 16px;
              color: #FFF;
            }
          }
        }
      }

      .btn-container {
        width: 320px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        color: #FFF;
        background: #4488FF;
        border-radius: 25px;
        margin: 0 auto;
        user-select: none;
        cursor: pointer;
      }
    }
  }
</style>
